export const DEVICES_BRIGHTNESS_LEVELS = [10, 25, 50, 75, 100];
export const DEVICES_BRIGHTNESS_DAY_MODE = 90;
export const DEVICES_BRIGHTNESS_NIGHT_MODE = 35;
